import * as Redux from 'react-redux'

import * as projectModel from '../../../models/project'
import { type TrackingExtraData, useProjectFollowing } from './useProjectFollowing'
import { toggleUserFollowingStatus } from '../../../../actions/fandom'
import { type RootState } from '../../../../reducers'

type UseProjectFollowingOptions = {
  trackingExtraData?: TrackingExtraData
}

type UseProjectFollowing = (options: UseProjectFollowingOptions) => {
  toggleFollowing: () => void
  userFollowsProject: boolean
}

export const useReduxProjectFollowing: UseProjectFollowing = ({ trackingExtraData }) => {
  const dispatch = Redux.useDispatch()
  const userFollowsProject = Redux.useSelector<RootState, boolean>((state) => state.application.fandom.userIsAFollower)
  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)

  const toggleFollowing = useProjectFollowing({
    callback: () => {
      dispatch(toggleUserFollowingStatus(!userFollowsProject))
    },
    project,
    trackingExtraData,
    userFollowsProject,
  })

  return { toggleFollowing, userFollowsProject }
}
